import { useQuery } from "react-query";
import Network from "../../network";

export default function useLibraries() {
    const {data} = useQuery('libraries', Network.getLibraries, {
        staleTime: Infinity
    });

    return {
        libraries: data || []
    }
}
